import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getStagePrompts } from '@/actions/stage-prompts/getStagePrompts';
import { StagePrompt } from '@/types/general-settings/stage.prompt.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetStagePromptsReturn {
  result: ApiResponse<StagePrompt[]> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetStagePrompts = (): UseGetStagePromptsReturn => {
  const query: UseQueryResult<ApiResponse<StagePrompt[]>, Error> = useQuery({
    queryKey: ['stage-prompts'],
    queryFn: getStagePrompts,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
